import { Truncate } from "@dropbox/dig-components/truncate";
import { Text } from "@dropbox/dig-components/typography";
import { Box, Stack } from "@dropbox/dig-foundations";
import { MagnifyingGlassMini } from "@dropbox/dig-illustrations";
import i18n, { Trans } from "@mirage/translations";

export const NoSearchResults = ({ query }: { query: string }) => {
  return (
    <Stack
      display="flex"
      gap="16"
      justify="center"
      align="center"
      height="fit-content"
      width="100%"
      paddingTop="52"
      paddingBottom="116"
    >
      <Box style={{ height: "72px", width: "72px" }}>
        <MagnifyingGlassMini altText={i18n.t("no_results")} />
      </Box>
      <Text
        variant="label"
        color="subtle"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Trans
          i18nKey="no_search_results_query"
          values={{ query }}
          components={{ truncate: <Truncate maxWidth={120}>{""}</Truncate> }}
        />
      </Text>
    </Stack>
  );
};
